import React from 'react';
import { Head } from 'vite-react-ssg';
import ClientSection from '../components/ClientSection';
import DetailsSection from '../components/DetailsSection';
import FooterSection from '../components/FooterSection';
import HeroSection from '../components/HeroSection';
import InfoSection from '../components/InfoSection';
import MapSection from '../components/MapSection';
import ServicesSection from '../components/ServicesSection';
import PoolCalculatorVideoSection from '../components/PoolCalculatorVideoSection';
import ProductsSection from '../components/ProductsSection';
import { WA_NUMBER } from '../constant/detail';

const localBusinessSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Pool Shop Surya Jaya Teknik - Ubud',
    url: 'https://poolshopsuryajayateknik.com',
    telephone: `+${WA_NUMBER}`,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Jalan Raya Andong, Petulu',
      addressLocality: 'Gianyar',
      addressRegion: 'Bali',
      postalCode: '80571',
      addressCountry: 'ID',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -8.495773472444835,
      longitude: 115.27369221532223,
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      opens: '08:00',
      closes: '17:00',
    },
    sameAs: 'https://goo.gl/maps/yPiN7QVSgGT7akcn8',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Pool Shop Surya Jaya Teknik - Lodtunduh',
    url: 'https://poolshopsuryajayateknik.com',
    telephone: `+${WA_NUMBER}`,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Jl. Raya Kengetan, Lodtunduh',
      addressLocality: 'Gianyar',
      addressRegion: 'Bali',
      postalCode: '80571',
      addressCountry: 'ID',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: -8.544770556862906,
      longitude: 115.26023002574675,
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      opens: '08:00',
      closes: '17:00',
    },
    sameAs: 'https://maps.app.goo.gl/gebnMK1ijneC67Yu9',
  },
];

const Home = () => {
  return (
    <div className="no-scrollbar">
      <Head>
        <title>Pool Shop Surya Jaya Teknik — No. 1 Pool Shop in Bali</title>
        <meta
          name="description"
          content="Pool Shop Surya Jaya Teknik — No. 1 pool shop in Bali. Jual chemical, pompa, filter & jasa maintenance kolam renang untuk villa, hotel & resor di Ubud, Gianyar, Badung, Denpasar."
        />
        <link rel="canonical" href="https://poolshopsuryajayateknik.com/" />
        <meta
          property="og:title"
          content="Pool Shop Surya Jaya Teknik — No. 1 Pool Shop in Bali"
        />
        <meta
          property="og:description"
          content="Pool Shop Surya Jaya Teknik — No. 1 pool shop in Bali. Chemical, pompa, filter & jasa maintenance kolam renang untuk villa, hotel & resor se-Bali."
        />
        <meta
          property="og:image"
          content="https://poolshopsuryajayateknik.com/img/blog/img-21.jpg"
        />
        <meta
          property="og:url"
          content="https://poolshopsuryajayateknik.com/"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Pool Shop Surya Jaya Teknik — No. 1 Pool Shop in Bali"
        />
        <meta
          name="twitter:description"
          content="Pool Shop Surya Jaya Teknik — No. 1 pool shop in Bali. Chemical, pompa, filter & jasa maintenance kolam renang untuk villa, hotel & resor se-Bali."
        />
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Head>
      <HeroSection />
      <InfoSection />
      <ServicesSection />
      <ClientSection />
      <PoolCalculatorVideoSection />
      <DetailsSection />
      <ProductsSection />
      <MapSection />
      <FooterSection />
    </div>
  );
};

export default Home;
